import { Routes } from '@angular/router';
import {UsersComponent} from "./users.component";
import { UserDetailComponent } from './user-detail/user-detail.component';


export const UsersRoutes: Routes = [{
	path: '',
	data: {
		title: 'Usuarios',
		status: false,
		breadcrumb: "Usuarios"
	},
	children: [
		{
			path: '',
			component: UsersComponent
		},
		{
			path: 'edit',
			component: UserDetailComponent,
			data: {
				breadcrumb: 'Editar',
				status: false
			}
		},
		{
			path: 'sales',
			component: UsersComponent,
			data: {
				breadcrumb: 'Equipo comercial',
				status: false,
				name: 'sales'
			}
		}
	]
}];



// WEBPACK FOOTER //
// ./src/app/components/users/users-routing.module.ts